import { startCase } from 'lodash';
import { format } from 'date-fns';
import InTransit from '../../../../assets/images/transit.png';
import OurForDelivery from '../../../../assets/images/out-for-delivery.png';
import InfoReceived from '../../../../assets/images/info-received.png';
import FailedAttempt from '../../../../assets/images/failed-attempt.png';
import Exception from '../../../../assets/images/exception.png';
import Delivered from '../../../../assets/images/delivered.png';
import AvaliableForPickUp from '../../../../assets/images/avaliable-for-pickup.png';

export const customEmailTemplateTypes = {
  AWAITING_SHIPMENT: {
    key: 'PRE_TRANSIT',
    label: 'Awaiting Shipment',
    imgSrc: InfoReceived,
    text: 'Pre-Transit',
    subText: 'After a label has been created, before the shipment is picked up',
  },
  IN_TRANSIT: {
    key: 'IN_TRANSIT',
    label: 'In Transit',
    imgSrc: InTransit,
    text: 'In Transit',
    subText:
      "After a shipment is picked up by the carrier and on it's way to the customer",
  },
  OUT_FOR_DELIVERY: {
    key: 'OUT_FOR_DELIVERY',
    label: 'Out for delivery',
    imgSrc: OurForDelivery,
    text: 'Out For delivery',
    subText: 'After a shipment is marked as out for delivery by the carrier',
  },
  DELIVERED: {
    key: 'DELIVERED',
    label: 'Delivered',
    imgSrc: Delivered,
    text: 'Delivered',
    subText: 'After a shipment is delivered',
  },
  RETURNED: {
    key: 'RETURN_TO_SENDER',
    label: 'Exception',
    imgSrc: Exception,
    text: 'Exception',
    subText: 'After a failed attempt to deliver to the customer',
  },
  FAILED_TO_DELIVER: {
    key: 'FAILURE',
    label: 'Failed Attempt',
    imgSrc: FailedAttempt,
    text: 'Failed Attempt',
    subText:
      'After the shipment is marked as having a problem and attention is needed',
  },
  AVALIABLE_FOR_PICKUP: {
    key: 'AVAILABLE_FOR_PICKUP',
    label: 'Avaliable for Pickup',
    imgSrc: AvaliableForPickUp,
    text: 'Avaliable For Pickup',
    subText: 'After a shipment is marked as pickup by the customer required',
  },
};

export const customTemplateVariables = {
  orderNumber: { key: 'order_number', label: 'Order Number' },
  recipientName: { key: 'recipient_name', label: 'Recipient Name' },
  trackingNumber: { key: 'tracking_number', label: 'Tracking Number' },
  trackingPageUrl: { key: 'tracking_page_url', label: 'Tracking Page URL' },
  deliveryDate: { key: 'delivery_date', label: 'Delivery Date' },
  status: { key: 'status', label: 'Order Status' },
};

export const templatesUsageTypes = {
  tracking: 'TRACKING',
  emails: 'EMAIL',
};

export const customEmailTemplateIntegrationTypes = {
  custom: 'CUSTOM',
};

export const defaultEmailTemplates = [
  {
    id: '1',
    eventType: customEmailTemplateTypes.AWAITING_SHIPMENT.key,
    active: false,
    sentCount: 0,
    subject: 'Your order is awaiting shipment',
    templateJson: {
      counters: {
        u_column: 1,
        u_row: 1,
        u_content_heading: 1,
        u_content_text: 5,
        u_content_button: 1,
        u_content_divider: 2,
      },
      body: {
        id: 'V3hx53usWj',
        rows: [
          {
            id: 'Us-8IZoVVu',
            cells: [1],
            columns: [
              {
                id: 'llV6UbMwgP',
                contents: [
                  {
                    id: 'P4iT7fxryz',
                    type: 'heading',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      headingType: 'h1',
                      fontSize: '29px',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_heading_1',
                        htmlClassNames: 'u_content_heading',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'Your order is awaiting shipment',
                    },
                  },
                  {
                    id: 'sCBa_U2ocd',
                    type: 'text',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_1',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 16px; line-height: 22.4px;">Your order is almost shipping to you!</span></p>',
                    },
                  },
                  {
                    id: 'GKsKAP7jU7',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        values: {
                          href: 'variable_link_to',
                          target: '_blank',
                        },
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                      },
                      buttonColors: {
                        color: '#FFFFFF',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_1',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="font-size: 14px; line-height: 16.8px;">TRACK ORDER</span>',
                      calculatedWidth: 142,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: 'OGe82WWmZ6',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_1',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'NwX1wB50Ry',
                    type: 'text',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_2',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%;">ESTIMATED DELIVERY</p>',
                    },
                  },
                  {
                    id: 'cMsNRIFX6g',
                    type: 'text',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_3',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%;">{{ delivery_date }}</p>',
                    },
                  },
                  {
                    id: 'c2xGYbwFh5',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_2',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'r3CIsYPIuA',
                    type: 'text',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_4',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">TRACKING NUMBER</p>',
                    },
                  },
                  {
                    id: 'WmlNyl2AsW',
                    type: 'text',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_5',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">{{ tracking_number }}</p>',
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  _meta: {
                    htmlID: 'u_column_1',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              hideDesktop: false,
              _meta: {
                htmlID: 'u_row_1',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          popupPosition: 'center',
          popupWidth: '600px',
          popupHeight: 'auto',
          borderRadius: '10px',
          contentAlign: 'center',
          contentVerticalAlign: 'center',
          contentWidth: '500px',
          fontFamily: {
            label: 'Arial',
            value: 'arial,helvetica,sans-serif',
          },
          textColor: '#000000',
          popupBackgroundColor: '#FFFFFF',
          popupBackgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'cover',
            position: 'center',
          },
          popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
          popupCloseButton_position: 'top-right',
          popupCloseButton_backgroundColor: '#DDDDDD',
          popupCloseButton_iconColor: '#000000',
          popupCloseButton_borderRadius: '0px',
          popupCloseButton_margin: '0px',
          popupCloseButton_action: {
            name: 'close_popup',
            attrs: {
              onClick:
                "document.querySelector('.u-popup-container').style.display = 'none';",
            },
          },
          backgroundColor: '#ffffff',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'custom',
            position: 'center',
          },
          preheaderText: '',
          linkStyle: {
            body: true,
            linkColor: '#0000ee',
            linkHoverColor: '#0000ee',
            linkUnderline: true,
            linkHoverUnderline: true,
          },
          _meta: {
            htmlID: 'u_body',
            htmlClassNames: 'u_body',
          },
        },
      },
      schemaVersion: 11,
    },
    templateHtml: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"> <html xmlns="http://www.w3.org/1999/xhtml"xmlns:v="urn:schemas-microsoft-com:vml"xmlns:o="urn:schemas-microsoft-com:office:office"> <head> <!--[if gte mso 9]>
    <xml>
      <o:OfficeDocumentSettings>
        <o:AllowPNG/>
        <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
    <![endif]--> <meta http-equiv="Content-Type"content="text/html; charset=UTF-8"> <meta name="viewport"content="width=device-width,initial-scale=1"> <meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible"content="IE=edge"><!--<![endif]--> <title></title> <style type="text/css">@media only screen and (min-width:520px){.u-row{width:500px!important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:500px!important}}@media (max-width:520px){.u-row-container{max-width:100%!important;padding-left:0!important;padding-right:0!important}.u-row .u-col{min-width:320px!important;max-width:100%!important;display:block!important}.u-row{width:100%!important}.u-col{width:100%!important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,td,tr{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table,.mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors=true]{color:inherit!important;text-decoration:none!important}table,td{color:#000}#u_body a{color:#00e;text-decoration:underline}</style> </head> <body class="clean-body u_body"style="margin:0;padding:0;-webkit-text-size-adjust:100%;background-color:#fff;color:#000"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--> <table id="u_body"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;min-width:320px;Margin:0 auto;background-color:#fff;width:100%"cellpadding="0"cellspacing="0"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #ffffff;"><![endif]--> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important"> <!--[if (!mso)&(!IE)]><!--><div style="height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <h1 style="margin:0;line-height:140%;text-align:center;word-wrap:break-word;font-weight:400;font-size:29px">Your order is awaiting shipment</h1> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:16px;line-height:22.4px">Your order is almost shipping to you!</span></p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="variable_link_to" style="height:37px; v-text-anchor:middle; width:142px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="variable_link_to"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none"> <span style="display:block;padding:10px 20px;line-height:120%"><span style="font-size:14px;line-height:16.8px">TRACK ORDER</span></span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">ESTIMATED DELIVERY</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">{{ delivery_date }}</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">TRACKING NUMBER</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">{{ tracking_number }}</p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <!--[if (mso)|(IE)]></td></tr></table><![endif]--> </td> </tr> </tbody> </table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--> </body> </html>`,
    usage: templatesUsageTypes.emails,
    platformIntegrationType: customEmailTemplateIntegrationTypes.custom,
  },
  {
    id: '2',
    eventType: customEmailTemplateTypes.IN_TRANSIT.key,
    active: false,
    sentCount: 0,
    subject: 'Your order is in transit',
    templateJson: {
      counters: {
        u_column: 1,
        u_row: 1,
        u_content_heading: 1,
        u_content_text: 5,
        u_content_button: 1,
        u_content_divider: 2,
      },
      body: {
        id: 'V3hx53usWj',
        rows: [
          {
            id: 'Us-8IZoVVu',
            cells: [1],
            columns: [
              {
                id: 'llV6UbMwgP',
                contents: [
                  {
                    id: 'P4iT7fxryz',
                    type: 'heading',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      headingType: 'h1',
                      fontSize: '29px',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_heading_1',
                        htmlClassNames: 'u_content_heading',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'Your order is shipping',
                    },
                  },
                  {
                    id: 'sCBa_U2ocd',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_1',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 16px; line-height: 22.4px;">Your order is in transit and is on its way to you.</span></p>',
                    },
                  },
                  {
                    id: 'GKsKAP7jU7',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        values: {
                          href: 'variable_link_to',
                          target: '_blank',
                        },
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                      },
                      buttonColors: {
                        color: '#FFFFFF',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_1',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="line-height: 16.8px;">TRACK ORDER</span>',
                      calculatedWidth: 142,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: 'OGe82WWmZ6',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_1',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'NwX1wB50Ry',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_2',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%;">ESTIMATED DELIVERY</p>',
                    },
                  },
                  {
                    id: 'cMsNRIFX6g',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_3',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%;">{{ delivery_date }}</p>',
                    },
                  },
                  {
                    id: 'c2xGYbwFh5',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_2',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'r3CIsYPIuA',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_4',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">TRACKING NUMBER</p>',
                    },
                  },
                  {
                    id: 'WmlNyl2AsW',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_5',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">{{ tracking_number }}</p>',
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  _meta: {
                    htmlID: 'u_column_1',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              hideDesktop: false,
              _meta: {
                htmlID: 'u_row_1',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          popupPosition: 'center',
          popupWidth: '600px',
          popupHeight: 'auto',
          borderRadius: '10px',
          contentAlign: 'center',
          contentVerticalAlign: 'center',
          contentWidth: '500px',
          fontFamily: {
            label: 'Arial',
            value: 'arial,helvetica,sans-serif',
          },
          textColor: '#000000',
          popupBackgroundColor: '#FFFFFF',
          popupBackgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'cover',
            position: 'center',
          },
          popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
          popupCloseButton_position: 'top-right',
          popupCloseButton_backgroundColor: '#DDDDDD',
          popupCloseButton_iconColor: '#000000',
          popupCloseButton_borderRadius: '0px',
          popupCloseButton_margin: '0px',
          popupCloseButton_action: {
            name: 'close_popup',
            attrs: {
              onClick:
                "document.querySelector('.u-popup-container').style.display = 'none';",
            },
          },
          backgroundColor: '#ffffff',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'custom',
            position: 'center',
          },
          preheaderText: '',
          linkStyle: {
            body: true,
            linkColor: '#0000ee',
            linkHoverColor: '#0000ee',
            linkUnderline: true,
            linkHoverUnderline: true,
          },
          _meta: {
            htmlID: 'u_body',
            htmlClassNames: 'u_body',
          },
        },
      },
      schemaVersion: 14,
    },
    templateHtml: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"> <html xmlns="http://www.w3.org/1999/xhtml"xmlns:v="urn:schemas-microsoft-com:vml"xmlns:o="urn:schemas-microsoft-com:office:office"> <head> <!--[if gte mso 9]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--> <meta http-equiv="Content-Type"content="text/html; charset=UTF-8"> <meta name="viewport"content="width=device-width,initial-scale=1"> <meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible"content="IE=edge"><!--<![endif]--> <title></title> <style type="text/css">@media only screen and (min-width:520px){.u-row{width:500px!important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:500px!important}}@media (max-width:520px){.u-row-container{max-width:100%!important;padding-left:0!important;padding-right:0!important}.u-row .u-col{min-width:320px!important;max-width:100%!important;display:block!important}.u-row{width:100%!important}.u-col{width:100%!important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,td,tr{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table,.mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors=true]{color:inherit!important;text-decoration:none!important}table,td{color:#000}#u_body a{color:#00e;text-decoration:underline}</style> </head> <body class="clean-body u_body"style="margin:0;padding:0;-webkit-text-size-adjust:100%;background-color:#fff;color:#000"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--> <table id="u_body"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;min-width:320px;Margin:0 auto;background-color:#fff;width:100%"cellpadding="0"cellspacing="0"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #ffffff;"><![endif]--> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <h1 style="margin:0;line-height:140%;text-align:center;word-wrap:break-word;font-size:29px;font-weight:400">Your order is shipping</h1> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:16px;line-height:22.4px">Your order is in transit and is on its way to you.</span></p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="variable_link_to" style="height:37px; v-text-anchor:middle; width:142px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="variable_link_to"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%"><span style="line-height:16.8px">TRACK ORDER</span></span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">ESTIMATED DELIVERY</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">{{ delivery_date }}</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">TRACKING NUMBER</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">{{ tracking_number }}</p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <!--[if (mso)|(IE)]></td></tr></table><![endif]--> </td> </tr> </tbody> </table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--> </body> </html>`,
    usage: templatesUsageTypes.emails,
    platformIntegrationType: customEmailTemplateIntegrationTypes.custom,
  },
  {
    id: '3',
    eventType: customEmailTemplateTypes.OUT_FOR_DELIVERY.key,
    active: false,
    sentCount: 0,
    subject: 'Your order is out for delivery',
    templateJson: {
      counters: {
        u_column: 1,
        u_row: 1,
        u_content_heading: 1,
        u_content_text: 5,
        u_content_button: 1,
        u_content_divider: 2,
      },
      body: {
        id: 'V3hx53usWj',
        rows: [
          {
            id: 'Us-8IZoVVu',
            cells: [1],
            columns: [
              {
                id: 'llV6UbMwgP',
                contents: [
                  {
                    id: 'P4iT7fxryz',
                    type: 'heading',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      headingType: 'h1',
                      fontSize: '29px',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_heading_1',
                        htmlClassNames: 'u_content_heading',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'Your order is out for delivery',
                    },
                  },
                  {
                    id: 'sCBa_U2ocd',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_1',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 16px; line-height: 22.4px;">Look out for it sometime today!</span></p>',
                    },
                  },
                  {
                    id: 'GKsKAP7jU7',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        values: {
                          href: 'variable_link_to',
                          target: '_blank',
                        },
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                      },
                      buttonColors: {
                        color: '#FFFFFF',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_1',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="font-size: 14px; line-height: 16.8px;">TRACK ORDER</span>',
                      calculatedWidth: 142,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: 'c2xGYbwFh5',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_2',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'r3CIsYPIuA',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_4',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">TRACKING NUMBER</p>',
                    },
                  },
                  {
                    id: 'WmlNyl2AsW',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_5',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">{{ tracking_number }}</p>',
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  _meta: {
                    htmlID: 'u_column_1',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              hideDesktop: false,
              _meta: {
                htmlID: 'u_row_1',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          popupPosition: 'center',
          popupWidth: '600px',
          popupHeight: 'auto',
          borderRadius: '10px',
          contentAlign: 'center',
          contentVerticalAlign: 'center',
          contentWidth: '500px',
          fontFamily: {
            label: 'Arial',
            value: 'arial,helvetica,sans-serif',
          },
          textColor: '#000000',
          popupBackgroundColor: '#FFFFFF',
          popupBackgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'cover',
            position: 'center',
          },
          popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
          popupCloseButton_position: 'top-right',
          popupCloseButton_backgroundColor: '#DDDDDD',
          popupCloseButton_iconColor: '#000000',
          popupCloseButton_borderRadius: '0px',
          popupCloseButton_margin: '0px',
          popupCloseButton_action: {
            name: 'close_popup',
            attrs: {
              onClick:
                "document.querySelector('.u-popup-container').style.display = 'none';",
            },
          },
          backgroundColor: '#ffffff',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'custom',
            position: 'center',
          },
          preheaderText: '',
          linkStyle: {
            body: true,
            linkColor: '#0000ee',
            linkHoverColor: '#0000ee',
            linkUnderline: true,
            linkHoverUnderline: true,
          },
          _meta: {
            htmlID: 'u_body',
            htmlClassNames: 'u_body',
          },
        },
      },
      schemaVersion: 14,
    },
    templateHtml: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"> <html xmlns="http://www.w3.org/1999/xhtml"xmlns:v="urn:schemas-microsoft-com:vml"xmlns:o="urn:schemas-microsoft-com:office:office"> <head> <!--[if gte mso 9]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--> <meta http-equiv="Content-Type"content="text/html; charset=UTF-8"> <meta name="viewport"content="width=device-width,initial-scale=1"> <meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible"content="IE=edge"><!--<![endif]--> <title></title> <style type="text/css">@media only screen and (min-width:520px){.u-row{width:500px!important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:500px!important}}@media (max-width:520px){.u-row-container{max-width:100%!important;padding-left:0!important;padding-right:0!important}.u-row .u-col{min-width:320px!important;max-width:100%!important;display:block!important}.u-row{width:100%!important}.u-col{width:100%!important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,td,tr{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table,.mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors=true]{color:inherit!important;text-decoration:none!important}table,td{color:#000}#u_body a{color:#00e;text-decoration:underline}</style> </head> <body class="clean-body u_body"style="margin:0;padding:0;-webkit-text-size-adjust:100%;background-color:#fff;color:#000"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--> <table id="u_body"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;min-width:320px;Margin:0 auto;background-color:#fff;width:100%"cellpadding="0"cellspacing="0"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #ffffff;"><![endif]--> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <h1 style="margin:0;line-height:140%;text-align:center;word-wrap:break-word;font-size:29px;font-weight:400">Your order is out for delivery</h1> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:16px;line-height:22.4px">Look out for it sometime today!</span></p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="variable_link_to" style="height:37px; v-text-anchor:middle; width:142px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="variable_link_to"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%"><span style="font-size:14px;line-height:16.8px">TRACK ORDER</span></span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">TRACKING NUMBER</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">{{ tracking_number }}</p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <!--[if (mso)|(IE)]></td></tr></table><![endif]--> </td> </tr> </tbody> </table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--> </body> </html>`,
    usage: templatesUsageTypes.emails,
    platformIntegrationType: customEmailTemplateIntegrationTypes.custom,
  },
  {
    id: '4',
    eventType: customEmailTemplateTypes.DELIVERED.key,
    active: false,
    sentCount: 0,
    subject: 'Your order is in delivered',
    templateJson: {
      counters: {
        u_column: 4,
        u_row: 3,
        u_content_heading: 1,
        u_content_text: 5,
        u_content_button: 2,
        u_content_divider: 2,
      },
      body: {
        id: 'V3hx53usWj',
        rows: [
          {
            id: 'Us-8IZoVVu',
            cells: [1],
            columns: [
              {
                id: 'llV6UbMwgP',
                contents: [
                  {
                    id: 'P4iT7fxryz',
                    type: 'heading',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      headingType: 'h1',
                      fontSize: '29px',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_heading_1',
                        htmlClassNames: 'u_content_heading',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'Your order has arrived!',
                    },
                  },
                  {
                    id: 'sCBa_U2ocd',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_1',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 16px; line-height: 22.4px;">The package has made it to you. We hope it\'s everything you want and more. Until next time!</span></p>\n<p style="font-size: 14px; line-height: 140%; text-align: center;"> </p>',
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  _meta: {
                    htmlID: 'u_column_1',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              hideDesktop: false,
              _meta: {
                htmlID: 'u_row_1',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
          {
            id: 'gz68btuvI_',
            cells: [1, 1],
            columns: [
              {
                id: 'Hvnxjqhqbc',
                contents: [
                  {
                    id: 'GKsKAP7jU7',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        values: {
                          href: 'variable_link_to',
                          target: '_blank',
                        },
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                      },
                      buttonColors: {
                        color: '#FFFFFF',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_1',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="line-height: 16.8px;">TRACK ORDER</span>',
                      calculatedWidth: 142,
                      calculatedHeight: 37,
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  borderRadius: '0px',
                  _meta: {
                    htmlID: 'u_column_2',
                    htmlClassNames: 'u_column',
                  },
                },
              },
              {
                id: '_016_ExZL8',
                contents: [
                  {
                    id: 'KR9uayvv1F',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                        values: {
                          href: 'https://resolve.shipaid.com',
                          target: '_blank',
                        },
                      },
                      buttonColors: {
                        color: '#ffffff',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_2',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'DELIVERY ISSUE',
                      calculatedWidth: 155,
                      calculatedHeight: 37,
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  borderRadius: '0px',
                  _meta: {
                    htmlID: 'u_column_3',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              _meta: {
                htmlID: 'u_row_2',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
          {
            id: '3LadcKuXkm',
            cells: [1],
            columns: [
              {
                id: 'SAH0VoH7c2',
                contents: [
                  {
                    id: 'c2xGYbwFh5',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_2',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'NwX1wB50Ry',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_2',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%;">DELIVERY DATE</p>',
                    },
                  },
                  {
                    id: 'cMsNRIFX6g',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_3',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%;">{{ delivery_date }}</p>',
                    },
                  },
                  {
                    id: 'OGe82WWmZ6',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_1',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'r3CIsYPIuA',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_4',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">TRACKING NUMBER</p>',
                    },
                  },
                  {
                    id: 'WmlNyl2AsW',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_5',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">{{ tracking_number }}</p>',
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  borderRadius: '0px',
                  _meta: {
                    htmlID: 'u_column_4',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              _meta: {
                htmlID: 'u_row_3',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          popupPosition: 'center',
          popupWidth: '600px',
          popupHeight: 'auto',
          borderRadius: '10px',
          contentAlign: 'center',
          contentVerticalAlign: 'center',
          contentWidth: '500px',
          fontFamily: {
            label: 'Arial',
            value: 'arial,helvetica,sans-serif',
          },
          textColor: '#000000',
          popupBackgroundColor: '#FFFFFF',
          popupBackgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'cover',
            position: 'center',
          },
          popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
          popupCloseButton_position: 'top-right',
          popupCloseButton_backgroundColor: '#DDDDDD',
          popupCloseButton_iconColor: '#000000',
          popupCloseButton_borderRadius: '0px',
          popupCloseButton_margin: '0px',
          popupCloseButton_action: {
            name: 'close_popup',
            attrs: {
              onClick:
                "document.querySelector('.u-popup-container').style.display = 'none';",
            },
          },
          backgroundColor: '#ffffff',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'custom',
            position: 'center',
          },
          preheaderText: '',
          linkStyle: {
            body: true,
            linkColor: '#0000ee',
            linkHoverColor: '#0000ee',
            linkUnderline: true,
            linkHoverUnderline: true,
          },
          _meta: {
            htmlID: 'u_body',
            htmlClassNames: 'u_body',
          },
        },
      },
      schemaVersion: 14,
    },
    templateHtml: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"> <html xmlns="http://www.w3.org/1999/xhtml"xmlns:v="urn:schemas-microsoft-com:vml"xmlns:o="urn:schemas-microsoft-com:office:office"> <head> <!--[if gte mso 9]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--> <meta http-equiv="Content-Type"content="text/html; charset=UTF-8"> <meta name="viewport"content="width=device-width,initial-scale=1"> <meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible"content="IE=edge"><!--<![endif]--> <title></title> <style type="text/css">@media only screen and (min-width:520px){.u-row{width:500px!important}.u-row .u-col{vertical-align:top}.u-row .u-col-50{width:250px!important}.u-row .u-col-100{width:500px!important}}@media (max-width:520px){.u-row-container{max-width:100%!important;padding-left:0!important;padding-right:0!important}.u-row .u-col{min-width:320px!important;max-width:100%!important;display:block!important}.u-row{width:100%!important}.u-col{width:100%!important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,td,tr{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table,.mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors=true]{color:inherit!important;text-decoration:none!important}table,td{color:#000}#u_body a{color:#00e;text-decoration:underline}</style> </head> <body class="clean-body u_body"style="margin:0;padding:0;-webkit-text-size-adjust:100%;background-color:#fff;color:#000"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--> <table id="u_body"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;min-width:320px;Margin:0 auto;background-color:#fff;width:100%"cellpadding="0"cellspacing="0"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #ffffff;"><![endif]--> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <h1 style="margin:0;line-height:140%;text-align:center;word-wrap:break-word;font-size:29px;font-weight:400">Your order has arrived!</h1> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:16px;line-height:22.4px">The package has made it to you. We hope it's everything you want and more. Until next time!</span></p> <p style="font-size:14px;line-height:140%;text-align:center"> </p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="250" style="width: 250px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]--> <div class="u-col u-col-50"style="max-width:320px;min-width:250px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="variable_link_to" style="height:37px; v-text-anchor:middle; width:142px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="variable_link_to"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%"><span style="line-height:16.8px">TRACK ORDER</span></span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="250" style="width: 250px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]--> <div class="u-col u-col-50"style="max-width:320px;min-width:250px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://resolve.shipaid.com" style="height:37px; v-text-anchor:middle; width:155px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#ffffff;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="https://resolve.shipaid.com"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%">DELIVERY ISSUE</span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">DELIVERY DATE</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">{{ delivery_date }}</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">TRACKING NUMBER</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">{{ tracking_number }}</p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <!--[if (mso)|(IE)]></td></tr></table><![endif]--> </td> </tr> </tbody> </table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--> </body> </html>`,
    usage: templatesUsageTypes.emails,
    platformIntegrationType: customEmailTemplateIntegrationTypes.custom,
  },
  {
    id: '5',
    eventType: customEmailTemplateTypes.FAILED_TO_DELIVER.key,
    active: false,
    sentCount: 0,
    subject: 'Delivery Failed for your order ',
    templateJson: {
      counters: {
        u_column: 1,
        u_row: 1,
        u_content_heading: 1,
        u_content_text: 5,
        u_content_button: 2,
        u_content_divider: 2,
      },
      body: {
        id: 'V3hx53usWj',
        rows: [
          {
            id: 'Us-8IZoVVu',
            cells: [1],
            columns: [
              {
                id: 'llV6UbMwgP',
                contents: [
                  {
                    id: 'P4iT7fxryz',
                    type: 'heading',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      headingType: 'h1',
                      fontSize: '29px',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_heading_1',
                        htmlClassNames: 'u_content_heading',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'Your order failed on delivery',
                    },
                  },
                  {
                    id: 'sCBa_U2ocd',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_1',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 16px; line-height: 22.4px;">Unfortunately your order failed to deliver, please contact the carrier or our team soon to get this resolved!</span></p>',
                    },
                  },
                  {
                    id: 'GKsKAP7jU7',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        values: {
                          href: 'variable_link_to',
                          target: '_blank',
                        },
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                      },
                      buttonColors: {
                        color: '#FFFFFF',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_1',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="font-size: 14px; line-height: 16.8px;">TRACK ORDER</span>',
                      calculatedWidth: 142,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: 'ipRTSUnKKi',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                        values: {
                          href: 'https://resolve.shipaid.com',
                          target: '_blank',
                        },
                      },
                      buttonColors: {
                        color: '#ffffff',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_2',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="line-height: 16.8px;">DELIVERY ISSUE</span>',
                      calculatedWidth: 155,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: 'c2xGYbwFh5',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_2',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'r3CIsYPIuA',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_4',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">TRACKING NUMBER</p>',
                    },
                  },
                  {
                    id: 'WmlNyl2AsW',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_5',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">{{ tracking_number }}</p>',
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  _meta: {
                    htmlID: 'u_column_1',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              hideDesktop: false,
              _meta: {
                htmlID: 'u_row_1',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          popupPosition: 'center',
          popupWidth: '600px',
          popupHeight: 'auto',
          borderRadius: '10px',
          contentAlign: 'center',
          contentVerticalAlign: 'center',
          contentWidth: '500px',
          fontFamily: {
            label: 'Arial',
            value: 'arial,helvetica,sans-serif',
          },
          textColor: '#000000',
          popupBackgroundColor: '#FFFFFF',
          popupBackgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'cover',
            position: 'center',
          },
          popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
          popupCloseButton_position: 'top-right',
          popupCloseButton_backgroundColor: '#DDDDDD',
          popupCloseButton_iconColor: '#000000',
          popupCloseButton_borderRadius: '0px',
          popupCloseButton_margin: '0px',
          popupCloseButton_action: {
            name: 'close_popup',
            attrs: {
              onClick:
                "document.querySelector('.u-popup-container').style.display = 'none';",
            },
          },
          backgroundColor: '#ffffff',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'custom',
            position: 'center',
          },
          preheaderText: '',
          linkStyle: {
            body: true,
            linkColor: '#0000ee',
            linkHoverColor: '#0000ee',
            linkUnderline: true,
            linkHoverUnderline: true,
          },
          _meta: {
            htmlID: 'u_body',
            htmlClassNames: 'u_body',
          },
        },
      },
      schemaVersion: 14,
    },
    templateHtml: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"> <html xmlns="http://www.w3.org/1999/xhtml"xmlns:v="urn:schemas-microsoft-com:vml"xmlns:o="urn:schemas-microsoft-com:office:office"> <head> <!--[if gte mso 9]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--> <meta http-equiv="Content-Type"content="text/html; charset=UTF-8"> <meta name="viewport"content="width=device-width,initial-scale=1"> <meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible"content="IE=edge"><!--<![endif]--> <title></title> <style type="text/css">@media only screen and (min-width:520px){.u-row{width:500px!important}.u-row .u-col{vertical-align:top}.u-row .u-col-50{width:250px!important}.u-row .u-col-100{width:500px!important}}@media (max-width:520px){.u-row-container{max-width:100%!important;padding-left:0!important;padding-right:0!important}.u-row .u-col{min-width:320px!important;max-width:100%!important;display:block!important}.u-row{width:100%!important}.u-col{width:100%!important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,td,tr{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table,.mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors=true]{color:inherit!important;text-decoration:none!important}table,td{color:#000}#u_body a{color:#00e;text-decoration:underline}</style> </head> <body class="clean-body u_body"style="margin:0;padding:0;-webkit-text-size-adjust:100%;background-color:#fff;color:#000"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--> <table id="u_body"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;min-width:320px;Margin:0 auto;background-color:#fff;width:100%"cellpadding="0"cellspacing="0"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #ffffff;"><![endif]--> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <h1 style="margin:0;line-height:140%;text-align:center;word-wrap:break-word;font-size:29px;font-weight:400">Your order has arrived!</h1> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:16px;line-height:22.4px">The package has made it to you. We hope it's everything you want and more. Until next time!</span></p> <p style="font-size:14px;line-height:140%;text-align:center"> </p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="250" style="width: 250px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]--> <div class="u-col u-col-50"style="max-width:320px;min-width:250px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="variable_link_to" style="height:37px; v-text-anchor:middle; width:142px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="variable_link_to"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%"><span style="line-height:16.8px">TRACK ORDER</span></span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="250" style="width: 250px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]--> <div class="u-col u-col-50"style="max-width:320px;min-width:250px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://resolve.shipaid.com" style="height:37px; v-text-anchor:middle; width:155px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#ffffff;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="https://resolve.shipaid.com"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%">DELIVERY ISSUE</span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;-webkit-border-radius: 0px; -moz-border-radius: 0px;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">DELIVERY DATE</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">{{ delivery_date }}</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">TRACKING NUMBER</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">{{ tracking_number }}</p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <!--[if (mso)|(IE)]></td></tr></table><![endif]--> </td> </tr> </tbody> </table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--> </body> </html>`,
    usage: templatesUsageTypes.emails,
    platformIntegrationType: customEmailTemplateIntegrationTypes.custom,
  },
  {
    id: '6',
    eventType: customEmailTemplateTypes.RETURNED.key,
    active: false,
    sentCount: 0,
    subject: 'Your order has some exeception',
    templateJson: {
      counters: {
        u_column: 1,
        u_row: 1,
        u_content_heading: 1,
        u_content_text: 5,
        u_content_button: 2,
        u_content_divider: 2,
      },
      body: {
        id: 'V3hx53usWj',
        rows: [
          {
            id: 'Us-8IZoVVu',
            cells: [1],
            columns: [
              {
                id: 'llV6UbMwgP',
                contents: [
                  {
                    id: 'P4iT7fxryz',
                    type: 'heading',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      headingType: 'h1',
                      fontSize: '29px',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_heading_1',
                        htmlClassNames: 'u_content_heading',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'There is a problem with your order',
                    },
                  },
                  {
                    id: 'sCBa_U2ocd',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_1',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 16px; line-height: 22.4px;">Please contact us or the carrier to get this resolved. Sorry for any inconvenience!</span></p>\n<p style="font-size: 14px; line-height: 140%; text-align: center;"> </p>',
                    },
                  },
                  {
                    id: 'GKsKAP7jU7',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        values: {
                          href: 'variable_link_to',
                          target: '_blank',
                        },
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                      },
                      buttonColors: {
                        color: '#FFFFFF',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_1',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="font-size: 14px; line-height: 16.8px;">TRACK ORDER</span>',
                      calculatedWidth: 142,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: '038mKaOSHz',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                        values: {
                          href: 'https://resolve.shipaid.com',
                          target: '_blank',
                        },
                      },
                      buttonColors: {
                        color: '#ffffff',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_2',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="line-height: 16.8px;">DELIVERY ISSUE</span>',
                      calculatedWidth: 155,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: 'c2xGYbwFh5',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_2',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'r3CIsYPIuA',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_4',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">TRACKING NUMBER</p>',
                    },
                  },
                  {
                    id: 'WmlNyl2AsW',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_5',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">{{ tracking_number }}</p>',
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  _meta: {
                    htmlID: 'u_column_1',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              hideDesktop: false,
              _meta: {
                htmlID: 'u_row_1',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          popupPosition: 'center',
          popupWidth: '600px',
          popupHeight: 'auto',
          borderRadius: '10px',
          contentAlign: 'center',
          contentVerticalAlign: 'center',
          contentWidth: '500px',
          fontFamily: {
            label: 'Arial',
            value: 'arial,helvetica,sans-serif',
          },
          textColor: '#000000',
          popupBackgroundColor: '#FFFFFF',
          popupBackgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'cover',
            position: 'center',
          },
          popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
          popupCloseButton_position: 'top-right',
          popupCloseButton_backgroundColor: '#DDDDDD',
          popupCloseButton_iconColor: '#000000',
          popupCloseButton_borderRadius: '0px',
          popupCloseButton_margin: '0px',
          popupCloseButton_action: {
            name: 'close_popup',
            attrs: {
              onClick:
                "document.querySelector('.u-popup-container').style.display = 'none';",
            },
          },
          backgroundColor: '#ffffff',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'custom',
            position: 'center',
          },
          preheaderText: '',
          linkStyle: {
            body: true,
            linkColor: '#0000ee',
            linkHoverColor: '#0000ee',
            linkUnderline: true,
            linkHoverUnderline: true,
          },
          _meta: {
            htmlID: 'u_body',
            htmlClassNames: 'u_body',
          },
        },
      },
      schemaVersion: 14,
    },
    templateHtml: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"> <html xmlns="http://www.w3.org/1999/xhtml"xmlns:v="urn:schemas-microsoft-com:vml"xmlns:o="urn:schemas-microsoft-com:office:office"> <head> <!--[if gte mso 9]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--> <meta http-equiv="Content-Type"content="text/html; charset=UTF-8"> <meta name="viewport"content="width=device-width,initial-scale=1"> <meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible"content="IE=edge"><!--<![endif]--> <title></title> <style type="text/css">@media only screen and (min-width:520px){.u-row{width:500px!important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:500px!important}}@media (max-width:520px){.u-row-container{max-width:100%!important;padding-left:0!important;padding-right:0!important}.u-row .u-col{min-width:320px!important;max-width:100%!important;display:block!important}.u-row{width:100%!important}.u-col{width:100%!important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,td,tr{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table,.mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors=true]{color:inherit!important;text-decoration:none!important}table,td{color:#000}#u_body a{color:#00e;text-decoration:underline}</style> </head> <body class="clean-body u_body"style="margin:0;padding:0;-webkit-text-size-adjust:100%;background-color:#fff;color:#000"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--> <table id="u_body"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;min-width:320px;Margin:0 auto;background-color:#fff;width:100%"cellpadding="0"cellspacing="0"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #ffffff;"><![endif]--> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <h1 style="margin:0;line-height:140%;text-align:center;word-wrap:break-word;font-size:29px;font-weight:400">There is a problem with your order</h1> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:16px;line-height:22.4px">Please contact us or the carrier to get this resolved. Sorry for any inconvenience!</span></p> <p style="font-size:14px;line-height:140%;text-align:center"> </p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="variable_link_to" style="height:37px; v-text-anchor:middle; width:142px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="variable_link_to"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%"><span style="font-size:14px;line-height:16.8px">TRACK ORDER</span></span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://resolve.shipaid.com" style="height:37px; v-text-anchor:middle; width:155px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#ffffff;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="https://resolve.shipaid.com"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%"><span style="line-height:16.8px">DELIVERY ISSUE</span></span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">TRACKING NUMBER</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">{{ tracking_number }}</p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <!--[if (mso)|(IE)]></td></tr></table><![endif]--> </td> </tr> </tbody> </table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--> </body> </html>`,
    usage: templatesUsageTypes.emails,
    platformIntegrationType: customEmailTemplateIntegrationTypes.custom,
  },
  {
    id: '7',
    eventType: customEmailTemplateTypes.AVALIABLE_FOR_PICKUP.key,
    active: false,
    sentCount: 0,
    subject: 'Your order is avaliable for pickup',
    templateJson: {
      counters: {
        u_column: 1,
        u_row: 1,
        u_content_heading: 1,
        u_content_text: 5,
        u_content_button: 2,
        u_content_divider: 2,
      },
      body: {
        id: 'V3hx53usWj',
        rows: [
          {
            id: 'Us-8IZoVVu',
            cells: [1],
            columns: [
              {
                id: 'llV6UbMwgP',
                contents: [
                  {
                    id: 'P4iT7fxryz',
                    type: 'heading',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      headingType: 'h1',
                      fontSize: '29px',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_heading_1',
                        htmlClassNames: 'u_content_heading',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'Your order is available for pickup',
                    },
                  },
                  {
                    id: 'sCBa_U2ocd',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_1',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 16px; line-height: 22.4px;">Please check the tracking below for more details and pick it up from a local hub soon. Thanks!</span></p>',
                    },
                  },
                  {
                    id: 'GKsKAP7jU7',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        values: {
                          href: 'variable_link_to',
                          target: '_blank',
                        },
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                      },
                      buttonColors: {
                        color: '#FFFFFF',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_1',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<span style="font-size: 14px; line-height: 16.8px;">TRACK ORDER</span>',
                      calculatedWidth: 142,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: 'KR8aRiD3DD',
                    type: 'button',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      href: {
                        name: 'web',
                        attrs: {
                          href: '{{href}}',
                          target: '{{target}}',
                        },
                        values: {
                          href: 'https://resolve.shipaid.com',
                          target: '_blank',
                        },
                      },
                      buttonColors: {
                        color: '#ffffff',
                        backgroundColor: '#000000',
                        hoverColor: '#FFFFFF',
                        hoverBackgroundColor: '#3AAEE0',
                      },
                      size: {
                        autoWidth: true,
                        width: '100%',
                      },
                      fontSize: '14px',
                      textAlign: 'center',
                      lineHeight: '120%',
                      padding: '10px 20px',
                      border: {},
                      borderRadius: '4px',
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_button_2',
                        htmlClassNames: 'u_content_button',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: 'DELIVERY ISSUE',
                      calculatedWidth: 155,
                      calculatedHeight: 37,
                    },
                  },
                  {
                    id: 'OGe82WWmZ6',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_1',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'NwX1wB50Ry',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_2',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%;">ESTIMATED DELIVERY</p>',
                    },
                  },
                  {
                    id: 'cMsNRIFX6g',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'center',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_3',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%;">{{ delivery_date }}</p>',
                    },
                  },
                  {
                    id: 'c2xGYbwFh5',
                    type: 'divider',
                    values: {
                      width: '100%',
                      border: {
                        borderTopWidth: '1px',
                        borderTopStyle: 'solid',
                        borderTopColor: '#BBBBBB',
                      },
                      textAlign: 'center',
                      containerPadding: '10px',
                      anchor: '',
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_divider_2',
                        htmlClassNames: 'u_content_divider',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                    },
                  },
                  {
                    id: 'r3CIsYPIuA',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_4',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">TRACKING NUMBER</p>',
                    },
                  },
                  {
                    id: 'WmlNyl2AsW',
                    type: 'text_deprecated',
                    values: {
                      containerPadding: '10px',
                      anchor: '',
                      textAlign: 'left',
                      lineHeight: '140%',
                      linkStyle: {
                        inherit: true,
                        linkColor: '#0000ee',
                        linkHoverColor: '#0000ee',
                        linkUnderline: true,
                        linkHoverUnderline: true,
                      },
                      hideDesktop: false,
                      displayCondition: null,
                      _meta: {
                        htmlID: 'u_content_text_5',
                        htmlClassNames: 'u_content_text',
                      },
                      selectable: true,
                      draggable: true,
                      duplicatable: true,
                      deletable: true,
                      hideable: true,
                      text: '<p style="font-size: 14px; line-height: 140%; text-align: center;">{{ tracking_number }}</p>',
                    },
                  },
                ],
                values: {
                  backgroundColor: '',
                  padding: '0px',
                  border: {},
                  _meta: {
                    htmlID: 'u_column_1',
                    htmlClassNames: 'u_column',
                  },
                },
              },
            ],
            values: {
              displayCondition: null,
              columns: false,
              backgroundColor: '',
              columnsBackgroundColor: '',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: 'no-repeat',
                size: 'custom',
                position: 'center',
              },
              padding: '0px',
              anchor: '',
              hideDesktop: false,
              _meta: {
                htmlID: 'u_row_1',
                htmlClassNames: 'u_row',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          popupPosition: 'center',
          popupWidth: '600px',
          popupHeight: 'auto',
          borderRadius: '10px',
          contentAlign: 'center',
          contentVerticalAlign: 'center',
          contentWidth: '500px',
          fontFamily: {
            label: 'Arial',
            value: 'arial,helvetica,sans-serif',
          },
          textColor: '#000000',
          popupBackgroundColor: '#FFFFFF',
          popupBackgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'cover',
            position: 'center',
          },
          popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
          popupCloseButton_position: 'top-right',
          popupCloseButton_backgroundColor: '#DDDDDD',
          popupCloseButton_iconColor: '#000000',
          popupCloseButton_borderRadius: '0px',
          popupCloseButton_margin: '0px',
          popupCloseButton_action: {
            name: 'close_popup',
            attrs: {
              onClick:
                "document.querySelector('.u-popup-container').style.display = 'none';",
            },
          },
          backgroundColor: '#ffffff',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: 'no-repeat',
            size: 'custom',
            position: 'center',
          },
          preheaderText: '',
          linkStyle: {
            body: true,
            linkColor: '#0000ee',
            linkHoverColor: '#0000ee',
            linkUnderline: true,
            linkHoverUnderline: true,
          },
          _meta: {
            htmlID: 'u_body',
            htmlClassNames: 'u_body',
          },
        },
      },
      schemaVersion: 14,
    },
    templateHtml: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"> <html xmlns="http://www.w3.org/1999/xhtml"xmlns:v="urn:schemas-microsoft-com:vml"xmlns:o="urn:schemas-microsoft-com:office:office"> <head> <!--[if gte mso 9]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--> <meta http-equiv="Content-Type"content="text/html; charset=UTF-8"> <meta name="viewport"content="width=device-width,initial-scale=1"> <meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible"content="IE=edge"><!--<![endif]--> <title></title> <style type="text/css">@media only screen and (min-width:520px){.u-row{width:500px!important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:500px!important}}@media (max-width:520px){.u-row-container{max-width:100%!important;padding-left:0!important;padding-right:0!important}.u-row .u-col{min-width:320px!important;max-width:100%!important;display:block!important}.u-row{width:100%!important}.u-col{width:100%!important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,td,tr{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table,.mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors=true]{color:inherit!important;text-decoration:none!important}table,td{color:#000}#u_body a{color:#00e;text-decoration:underline}</style> </head> <body class="clean-body u_body"style="margin:0;padding:0;-webkit-text-size-adjust:100%;background-color:#fff;color:#000"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--> <table id="u_body"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;min-width:320px;Margin:0 auto;background-color:#fff;width:100%"cellpadding="0"cellspacing="0"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #ffffff;"><![endif]--> <div class="u-row-container"style="padding:0;background-color:transparent"> <div class="u-row"style="Margin:0 auto;min-width:320px;max-width:500px;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;background-color:transparent"> <div style="border-collapse:collapse;display:table;width:100%;height:100%;background-color:transparent"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:500px;"><tr style="background-color: transparent;"><![endif]--> <!--[if (mso)|(IE)]><td align="center" width="500" style="width: 500px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--> <div class="u-col u-col-100"style="max-width:320px;min-width:500px;display:table-cell;vertical-align:top"> <div style="height:100%;width:100%!important"> <!--[if (!mso)&(!IE)]><!--><div style="box-sizing:border-box;height:100%;padding:0;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent"><!--<![endif]--> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <h1 style="margin:0;line-height:140%;text-align:center;word-wrap:break-word;font-size:29px;font-weight:400">Your order is available for pickup</h1> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:16px;line-height:22.4px">Please check the tracking below for more details and pick it up from a local hub soon. Thanks!</span></p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="variable_link_to" style="height:37px; v-text-anchor:middle; width:142px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#FFFFFF;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="variable_link_to"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%"><span style="font-size:14px;line-height:16.8px">TRACK ORDER</span></span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <!--[if mso]><style>.v-button {background: transparent !important;}</style><![endif]--> <div align="center"> <!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://resolve.shipaid.com" style="height:37px; v-text-anchor:middle; width:155px;" arcsize="11%"  stroke="f" fillcolor="#000000"><w:anchorlock/><center style="color:#ffffff;font-family:arial,helvetica,sans-serif;"><![endif]--> <a href="https://resolve.shipaid.com"target="_blank"class="v-button"style="box-sizing:border-box;display:inline-block;font-family:arial,helvetica,sans-serif;text-decoration:none;-webkit-text-size-adjust:none;text-align:center;color:#fff;background-color:#000;border-radius:4px;-webkit-border-radius:4px;-moz-border-radius:4px;width:auto;max-width:100%;overflow-wrap:break-word;word-break:break-word;word-wrap:break-word;mso-border-alt:none;font-size:14px"> <span style="display:block;padding:10px 20px;line-height:120%">DELIVERY ISSUE</span> </a> <!--[if mso]></center></v:roundrect><![endif]--> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">ESTIMATED DELIVERY</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%">{{ delivery_date }}</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <table height="0px"align="center"border="0"cellpadding="0"cellspacing="0"width="100%"style="border-collapse:collapse;table-layout:fixed;border-spacing:0;mso-table-lspace:0;mso-table-rspace:0;vertical-align:top;border-top:1px solid #bbb;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <tbody> <tr style="vertical-align:top"> <td style="word-break:break-word;border-collapse:collapse!important;vertical-align:top;font-size:0;line-height:0;mso-line-height-rule:exactly;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%"> <span>&#160;</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">TRACKING NUMBER</p> </div> </td> </tr> </tbody> </table> <table style="font-family:arial,helvetica,sans-serif"role="presentation"cellpadding="0"cellspacing="0"width="100%"border="0"> <tbody> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:10px;font-family:arial,helvetica,sans-serif"align="left"> <div style="line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center">{{ tracking_number }}</p> </div> </td> </tr> </tbody> </table> <!--[if (!mso)&(!IE)]><!--></div><!--<![endif]--> </div> </div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--> </div> </div> </div> <!--[if (mso)|(IE)]></td></tr></table><![endif]--> </td> </tr> </tbody> </table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--> </body> </html>`,
    usage: templatesUsageTypes.emails,
    platformIntegrationType: customEmailTemplateIntegrationTypes.custom,
  },
];

export const defaultTrackingTemplate = {
  id: '100',
  isTrackingDefault: true,
  active: true,
  subject: 'tracking',
  eventType: null,
  templateJson: {
    body: {
      id: 'V3hx53usWj',
      rows: [
        {
          id: 'gbYSr1TV7S',
          cells: [1],
          values: {
            _meta: { htmlID: 'u_row_3', htmlClassNames: 'u_row' },
            anchor: '',
            columns: false,
            padding: '0px',
            hideable: true,
            deletable: true,
            draggable: true,
            selectable: true,
            hideDesktop: false,
            duplicatable: true,
            backgroundColor: '',
            backgroundImage: {
              url: '',
              size: 'custom',
              repeat: 'no-repeat',
              position: 'center',
              fullWidth: true,
            },
            displayCondition: null,
            columnsBackgroundColor: '',
          },
          columns: [
            {
              id: 'nxhhAEtzw3',
              values: {
                _meta: { htmlID: 'u_column_4', htmlClassNames: 'u_column' },
                border: {},
                padding: '22px',
                _override: { mobile: { padding: '0px' } },
                borderRadius: '0px',
                backgroundColor: '',
              },
              contents: [],
            },
          ],
        },
        {
          id: 'UX5-jJ9hKk',
          cells: [1, 1],
          values: {
            _meta: { htmlID: 'u_row_2', htmlClassNames: 'u_row' },
            anchor: '',
            columns: false,
            padding: '0px',
            hideable: true,
            deletable: true,
            draggable: true,
            selectable: true,
            hideDesktop: false,
            duplicatable: true,
            backgroundColor: '',
            backgroundImage: {
              url: '',
              size: 'custom',
              repeat: 'no-repeat',
              position: 'center',
              fullWidth: true,
            },
            displayCondition: null,
            columnsBackgroundColor: '',
          },
          columns: [
            {
              id: 'v1mx4MK4Xd',
              values: {
                _meta: { htmlID: 'u_column_2', htmlClassNames: 'u_column' },
                border: {},
                padding: '0px',
                borderRadius: '4px',
                backgroundColor: '',
              },
              contents: [
                {
                  id: 'Hmm_MPUcHr',
                  type: 'image',
                  values: {
                    src: {
                      id: 548285,
                      url: 'https://assets.unlayer.com/projects/158410/1689212911724-91219.png',
                      width: 1000,
                      author: {
                        url: 'https://pixabay.com/photos/gift-parcel-surprise-ribbon-548285/',
                        name: 'blickpixel',
                      },
                      height: 749,
                      preview: {
                        url: 'https://pixabay.com/get/g61a844e7cb9679bd6801844c9854409c37198dafdf02012d64ec62e96edcd195a3516c6280b406035d90686b625b3c1b_640.jpg',
                        width: 640,
                        height: 426,
                      },
                      platform: { url: 'https://pixabay.com', name: 'Pixabay' },
                    },
                    _meta: {
                      htmlID: 'u_content_image_1',
                      htmlClassNames: 'u_content_image',
                    },
                    action: {
                      name: 'web',
                      values: { href: '', target: '_blank' },
                    },
                    anchor: '',
                    altText: '',
                    pending: false,
                    hideable: true,
                    _override: { mobile: { hideMobile: true } },
                    deletable: true,
                    draggable: true,
                    textAlign: 'center',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '0px 10px 0px 0px',
                    displayCondition: null,
                  },
                },
              ],
            },
            {
              id: 'dsGl2p4ue5',
              values: {
                _meta: { htmlID: 'u_column_3', htmlClassNames: 'u_column' },
                border: {},
                padding: '0px',
                borderRadius: '20px',
                backgroundColor: '#ffffff',
              },
              contents: [
                {
                  id: 'P4iT7fxryz',
                  type: 'heading',
                  values: {
                    text: 'Hi {{ recipient_name }}!',
                    _meta: {
                      htmlID: 'u_content_heading_1',
                      htmlClassNames: 'u_content_heading',
                    },
                    anchor: '',
                    fontSize: '45px',
                    hideable: true,
                    _override: { mobile: { fontSize: '26px' } },
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'left',
                    lineHeight: '140%',
                    selectable: true,
                    headingType: 'h1',
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                },
                {
                  id: 'sCBa_U2ocd',
                  type: 'text',
                  values: {
                    text: '<p style="line-height: 140%;">You order status is {{ status }}. Thank you for shopping with us!</p>',
                    _meta: {
                      htmlID: 'u_content_text_1',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'left',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                  hasDeprecatedFontControls: true,
                },
                {
                  id: 'Vm55VE16HH',
                  type: 'divider',
                  values: {
                    _meta: {
                      htmlID: 'u_content_divider_4',
                      htmlClassNames: 'u_content_divider',
                    },
                    width: '100%',
                    anchor: '',
                    border: {
                      borderTopColor: '#3ca0ff',
                      borderTopStyle: 'solid',
                      borderTopWidth: '2px',
                    },
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    textAlign: 'center',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                },
                {
                  id: 'r3CIsYPIuA',
                  type: 'text',
                  values: {
                    text: '<p style="font-size: 14px; line-height: 140%; text-align: left;">ORDER</p>',
                    _meta: {
                      htmlID: 'u_content_text_4',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'left',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                  hasDeprecatedFontControls: true,
                },
                {
                  id: 'gPsX5IldoN',
                  type: 'text',
                  values: {
                    text: '<p style="line-height: 140%;">{{ order_number }}</p>',
                    _meta: {
                      htmlID: 'u_content_text_6',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'left',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                },
                {
                  id: 'c2xGYbwFh5',
                  type: 'divider',
                  values: {
                    _meta: {
                      htmlID: 'u_content_divider_2',
                      htmlClassNames: 'u_content_divider',
                    },
                    width: '100%',
                    anchor: '',
                    border: {
                      borderTopColor: '#3ca0ff',
                      borderTopStyle: 'solid',
                      borderTopWidth: '2px',
                    },
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    textAlign: 'center',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                },
                {
                  id: 'NwX1wB50Ry',
                  type: 'text',
                  values: {
                    text: '<p style="font-size: 14px; line-height: 140%; text-align: left;">ESTIMATED DELIVERY</p>',
                    _meta: {
                      htmlID: 'u_content_text_2',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'left',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                  hasDeprecatedFontControls: true,
                },
                {
                  id: 'cMsNRIFX6g',
                  type: 'text',
                  values: {
                    text: '<p style="font-size: 14px; line-height: 140%; text-align: left;">{{ delivery_date }}</p>',
                    _meta: {
                      htmlID: 'u_content_text_3',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'left',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                  hasDeprecatedFontControls: true,
                },
                {
                  id: '1z4hw8wrts',
                  type: 'divider',
                  values: {
                    _meta: {
                      htmlID: 'u_content_divider_3',
                      htmlClassNames: 'u_content_divider',
                    },
                    width: '100%',
                    anchor: '',
                    border: {
                      borderTopColor: '#3ca0ff',
                      borderTopStyle: 'solid',
                      borderTopWidth: '2px',
                    },
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    textAlign: 'center',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                },
                {
                  id: 'p2Gg1Acx7h',
                  type: 'text',
                  values: {
                    text: '<p style="font-size: 14px; line-height: 140%; text-align: left;">TRACKING NUMBER</p>',
                    _meta: {
                      htmlID: 'u_content_text_8',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'left',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                  hasDeprecatedFontControls: true,
                },
                {
                  id: 'WmlNyl2AsW',
                  type: 'text',
                  values: {
                    text: '<p style="font-size: 14px; line-height: 140%; text-align: left;">{{ tracking_number }}</p>',
                    _meta: {
                      htmlID: 'u_content_text_5',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'left',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                  hasDeprecatedFontControls: true,
                },
              ],
            },
          ],
        },
        {
          id: 'Us-8IZoVVu',
          cells: [1, 1],
          values: {
            _meta: { htmlID: 'u_row_1', htmlClassNames: 'u_row' },
            anchor: '',
            columns: false,
            padding: '0px',
            hideable: true,
            deletable: true,
            draggable: true,
            selectable: true,
            hideDesktop: false,
            duplicatable: true,
            backgroundColor: '',
            backgroundImage: {
              url: '',
              size: 'custom',
              repeat: 'no-repeat',
              position: 'center',
              fullWidth: true,
            },
            displayCondition: null,
            columnsBackgroundColor: '',
          },
          columns: [
            {
              id: 'llV6UbMwgP',
              values: {
                _meta: { htmlID: 'u_column_1', htmlClassNames: 'u_column' },
                border: {},
                padding: '0px',
                backgroundColor: '',
              },
              contents: [
                {
                  id: 'qut-IBu28h',
                  type: 'text',
                  values: {
                    text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 30px; line-height: 42px;">TRACKING HISTORY</span></p>',
                    _meta: {
                      htmlID: 'u_content_text_7',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'center',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                  hasDeprecatedFontControls: true,
                },
                {
                  id: 'EJvv0qn-0U',
                  slug: 'shipaid_tools',
                  type: 'custom',
                  values: {
                    tool: 'tracking',
                    _meta: {
                      htmlID: 'u_content_custom_shipaid_tools_4',
                      htmlClassNames: 'u_content_custom_shipaid_tools',
                    },
                    anchor: '',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    scrollable: true,
                    selectable: true,
                    accordionRow: { items: [] },
                    duplicatable: true,
                    productColor: '#1664C0',
                    maxScrollHeight: '400',
                    containerPadding: '10px',
                    detailTitleColor: '#4E626A',
                    displayCondition: null,
                    productBackground: '#ffffff',
                    trackingTitleColor: '#1664C0',
                    trackingBrackground: '#ffffff',
                    accordionTitleTextColor: '#212121',
                    trackingTitleBackground: '#F5F8F8',
                    accordionDescriptionTextColor: '#212121',
                    accordionTitleBackgroundColor: '#FAFAFA',
                    accordionTitleHoverBackground: '#ECEDEF',
                    accordionDescriptionBackgroundColor: '#fff',
                  },
                },
              ],
            },
            {
              id: 'zIxUNPUwGW',
              values: {
                _meta: { htmlID: 'u_column_7', htmlClassNames: 'u_column' },
                border: {},
                padding: '0px',
                borderRadius: '0px',
                backgroundColor: '',
              },
              contents: [
                {
                  id: '1NLrkKqZKE',
                  type: 'text',
                  values: {
                    text: '<p style="font-size: 14px; line-height: 140%; text-align: center;"><span style="font-size: 30px; line-height: 42px;">ORDER CONTENTS</span></p>',
                    _meta: {
                      htmlID: 'u_content_text_9',
                      htmlClassNames: 'u_content_text',
                    },
                    anchor: '',
                    fontSize: '14px',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    linkStyle: {
                      inherit: true,
                      linkColor: '#0000ee',
                      linkUnderline: true,
                      linkHoverColor: '#0000ee',
                      linkHoverUnderline: true,
                    },
                    textAlign: 'center',
                    lineHeight: '140%',
                    selectable: true,
                    hideDesktop: false,
                    duplicatable: true,
                    containerPadding: '10px',
                    displayCondition: null,
                  },
                  hasDeprecatedFontControls: true,
                },
                {
                  id: 'WwSNosYHdD',
                  slug: 'shipaid_tools',
                  type: 'custom',
                  values: {
                    tool: 'product',
                    _meta: {
                      htmlID: 'u_content_custom_shipaid_tools_2',
                      htmlClassNames: 'u_content_custom_shipaid_tools',
                    },
                    anchor: '',
                    hideable: true,
                    deletable: true,
                    draggable: true,
                    scrollable: true,
                    selectable: true,
                    accordionRow: { items: [] },
                    duplicatable: true,
                    productColor: '#1664C0',
                    maxScrollHeight: '400',
                    containerPadding: '10px',
                    detailTitleColor: '#4E626A',
                    displayCondition: null,
                    productBackground: '#ffffff',
                    trackingTitleColor: '#1664C0',
                    trackingBrackground: '#ffffff',
                    accordionTitleTextColor: '#212121',
                    trackingTitleBackground: '#F5F8F8',
                    accordionDescriptionTextColor: '#212121',
                    accordionTitleBackgroundColor: '#FAFAFA',
                    accordionTitleHoverBackground: '#ECEDEF',
                    accordionDescriptionBackgroundColor: '#fff',
                  },
                },
              ],
            },
          ],
        },
      ],
      values: {
        _meta: { htmlID: 'u_body', htmlClassNames: 'u_body' },
        linkStyle: {
          body: true,
          linkColor: '#0000ee',
          linkUnderline: true,
          linkHoverColor: '#0000ee',
          linkHoverUnderline: true,
        },
        textColor: '#000000',
        fontFamily: {
          url: 'https://fonts.googleapis.com/css?family=Rubik:400,700',
          label: 'Rubik',
          value: "'Rubik',sans-serif",
          weights: [400, 700],
          defaultFont: true,
        },
        fontWeight: 400,
        popupWidth: '600px',
        popupHeight: 'auto',
        borderRadius: '10px',
        contentAlign: 'center',
        contentWidth: '1100px',
        popupPosition: 'center',
        preheaderText: '',
        backgroundColor: '#f7fafd',
        backgroundImage: {
          url: '',
          size: 'custom',
          repeat: 'no-repeat',
          position: 'center',
          fullWidth: true,
        },
        contentVerticalAlign: 'center',
        popupBackgroundColor: '#FFFFFF',
        popupBackgroundImage: {
          url: '',
          size: 'cover',
          repeat: 'no-repeat',
          position: 'center',
          fullWidth: true,
        },
        popupCloseButton_action: {
          name: 'close_popup',
          attrs: {
            onClick:
              "document.querySelector('.u-popup-container').style.display = 'none';",
          },
        },
        popupCloseButton_margin: '0px',
        popupCloseButton_position: 'top-right',
        popupCloseButton_iconColor: '#000000',
        popupOverlay_backgroundColor: 'rgba(0, 0, 0, 0.1)',
        popupCloseButton_borderRadius: '0px',
        popupCloseButton_backgroundColor: '#DDDDDD',
      },
    },
    counters: {
      u_row: 5,
      u_column: 7,
      u_content_text: 9,
      u_content_image: 1,
      u_content_button: 1,
      u_content_divider: 4,
      u_content_heading: 1,
      u_content_custom_shipaid_tools: 4,
    },
    schemaVersion: 15,
  },
  templateHtml: `<!doctype html> <html> <head> <meta charset="utf-8"> <meta http-equiv="x-ua-compatible"content="ie=edge"> <title></title> <meta name="description"content=""> <meta name="viewport"content="width=device-width,initial-scale=1"> <link href="https://fonts.googleapis.com/css?family=Rubik:400,700"rel="stylesheet"type="text/css"> <style type="text/css">.u-row{display:flex;flex-wrap:nowrap;margin-left:0;margin-right:0}.u-row .u-col{position:relative;width:100%;padding-right:0;padding-left:0}.u-row .u-col.u-col-50{flex:0 0 50%;max-width:50%}.u-row .u-col.u-col-100{flex:0 0 100%;max-width:100%}@media (max-width:767px){.u-row:not(.no-stack){flex-wrap:wrap}.u-row:not(.no-stack) .u-col{flex:0 0 100%!important;max-width:100%!important}}body,html{padding:0;margin:0}html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}html{font-size:14px;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:transparent}p{margin:0}form .error-field{-webkit-animation-name:shake;animation-name:shake;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}form .error-field input,form .error-field textarea{border-color:#a94442!important;color:#a94442!important}form .field-error{padding:5px 10px;font-size:14px;font-weight:700;position:absolute;top:-20px;right:10px}form .field-error:after{top:100%;left:50%;border:solid transparent;content:" ";height:0;width:0;position:absolute;pointer-events:none;border-color:rgba(136,183,213,0);border-top-color:#ebcccc;border-width:5px;margin-left:-5px}form .spinner{margin:0 auto;width:70px;text-align:center}form .spinner>div{width:12px;height:12px;background-color:hsla(0,0%,100%,.5);margin:0 2px;border-radius:100%;display:inline-block;-webkit-animation:sk-bouncedelay 1.4s infinite ease-in-out both;animation:sk-bouncedelay 1.4s infinite ease-in-out both}form .spinner .bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}form .spinner .bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@media (max-width:480px){.hide-mobile{display:none!important}.container{max-width:100%!important}}@media (min-width:481px) and (max-width:768px){.hide-tablet{display:none!important}}.container{width:100%;padding-right:0;padding-left:0;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}a[onclick]{cursor:pointer}body{font-family:Rubik,sans-serif;font-size:1rem;line-height:1.5;color:#000;background-color:#f7fafd;font-weight:400}#u_body a{color:#00e;text-decoration:underline}#u_body a:hover{color:#00e;text-decoration:underline}.tracking-title{padding:8px}.product-quantity,.product-title{margin-left:8px}.detail-content{padding:8px;display:-webkit-box;display:-ms-flexbox;display:flex;color:#bac8cb}.detail-info-container{margin-left:8px}.detail-date,.detail-status{font-weight:700}.detail-date{width:70px}.accordion{background-color:#fafafa;color:#212121;cursor:pointer;padding:18px;width:100%;border:none;text-align:left;outline:0;font-size:15px;transition:.4s;margin-top:3px}.accordion:hover{background-color:#ecedef}.panel{padding:0 18px;display:none;width:100%;background-color:#fff;color:#212121;overflow:hidden;border-top:1px solid #f2f2f2}.tracking-title{padding:8px}.product-quantity,.product-title{margin-left:8px}.detail-content{padding:8px;display:-webkit-box;display:-ms-flexbox;display:flex;color:#bac8cb}.detail-info-container{margin-left:8px}.detail-date,.detail-status{font-weight:700}.detail-date{width:70px}.accordion{background-color:#fafafa;color:#212121;cursor:pointer;padding:18px;width:100%;border:none;text-align:left;outline:0;font-size:15px;transition:.4s;margin-top:3px}.accordion:hover{background-color:#ecedef}.panel{padding:0 18px;display:none;width:100%;background-color:#fff;color:#212121;overflow:hidden;border-top:1px solid #f2f2f2}@media (max-width:480px){#u_column_4 .v-col-padding{padding:0!important}#u_content_heading_1 .v-font-size{font-size:26px!important}}</style> <script type="application/javascript"> async function handleAccordionClick(item){          let panel = item.nextElementSibling          if (panel.style.display === "block") {            panel.style.display = "none";          } else {            panel.style.display = "block";          }        }async function handleAccordionClick(item){          let panel = item.nextElementSibling          if (panel.style.display === "block") {            panel.style.display = "none";          } else {            panel.style.display = "block";          }        } </script> </head> <body> <div id="u_body"class="u_body"style="min-height:100vh"> <div id="u_row_3"class="u_row"style="padding:0"> <div class="container"style="max-width:1100px;margin:0 auto"> <div class="u-row"> <div id="u_column_4"class="u-col u-col-100 u_column"style="display:flex;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:0"> <div class="v-col-padding"style="width:100%;padding:22px"> </div> </div> </div> </div> </div> <div id="u_row_2"class="u_row"style="padding:0"> <div class="container"style="max-width:1100px;margin:0 auto"> <div class="u-row"> <div id="u_column_2"class="u-col u-col-50 u_column"style="display:flex;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:4px"> <div class="v-col-padding"style="width:100%;padding:0"> <div id="u_content_image_1"class="u_content_image hide-mobile"style="overflow-wrap:break-word;padding:0 10px 0 0"> <div style="position:relative;line-height:0;text-align:center"> <img alt=""src="https://assets.unlayer.com/projects/158410/1689212911724-91219.png"style="width:100%;max-width:1000px"title=""> </div> </div> </div> </div> <div id="u_column_3"class="u-col u-col-50 u_column"style="display:flex;background-color:#fff;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:20px"> <div class="v-col-padding"style="width:100%;padding:0"> <div id="u_content_heading_1"class="u_content_heading"style="overflow-wrap:break-word;padding:10px"> <h1 class="v-font-size"style="margin:0;line-height:140%;text-align:left;word-wrap:break-word;font-size:45px;font-weight:400">Hi {{ recipient_name }}!</h1> </div> <div id="u_content_text_1"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:left;word-wrap:break-word"> <p style="line-height:140%">You order status is {{ status }}. Thank you for shopping with us!</p> </div> </div> <div id="u_content_divider_4"class="u_content_divider"style="overflow-wrap:break-word;padding:10px"> <div style="text-align:center;line-height:0"><div style="border-top-width:2px;border-top-style:solid;border-top-color:#3ca0ff;width:100%;display:inline-block;line-height:2px;height:0;vertical-align:middle"> </div></div> </div> <div id="u_content_text_4"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:left">ORDER</p> </div> </div> <div id="u_content_text_6"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:left;word-wrap:break-word"> <p style="line-height:140%">{{ order_number }}</p> </div> </div> <div id="u_content_divider_2"class="u_content_divider"style="overflow-wrap:break-word;padding:10px"> <div style="text-align:center;line-height:0"><div style="border-top-width:2px;border-top-style:solid;border-top-color:#3ca0ff;width:100%;display:inline-block;line-height:2px;height:0;vertical-align:middle"> </div></div> </div> <div id="u_content_text_2"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:left">ESTIMATED DELIVERY</p> </div> </div> <div id="u_content_text_3"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:left">{{ delivery_date }}</p> </div> </div> <div id="u_content_divider_3"class="u_content_divider"style="overflow-wrap:break-word;padding:10px"> <div style="text-align:center;line-height:0"><div style="border-top-width:2px;border-top-style:solid;border-top-color:#3ca0ff;width:100%;display:inline-block;line-height:2px;height:0;vertical-align:middle"> </div></div> </div> <div id="u_content_text_8"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:left">TRACKING NUMBER</p> </div> </div> <div id="u_content_text_5"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:left;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:left">{{ tracking_number }}</p> </div> </div> </div> </div> </div> </div> </div> <div id="u_row_1"class="u_row"style="padding:0"> <div class="container"style="max-width:1100px;margin:0 auto"> <div class="u-row"> <div id="u_column_1"class="u-col u-col-50 u_column"style="display:flex;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent"> <div class="v-col-padding"style="width:100%;padding:0"> <div id="u_content_text_7"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:30px;line-height:42px">TRACKING HISTORY</span></p> </div> </div> <div id="u_content_custom_shipaid_tools_4"class="u_content_custom_shipaid_tools"style="overflow-wrap:break-word;padding:10px"> <article style="background-color:#fff;overflow-y:auto;max-height:400px"class="tracking-container"> {{#each trackingDetails}} <div class="tracking-title"style="color:#1664c0;background-color:#f5f8f8"> {{date_time}} </div> {{#each details}} <article class="detail-content"> <div class="detail-date"> {{time}} </div> <div class="detail-info-container"> <div class="detail-status"style="color:#4e626a"> {{message}}</div> <div class="detail-local"> {{address}} </div> </div> </article> {{/each}} {{/each}} </article> </div> </div> </div> <div id="u_column_7"class="u-col u-col-50 u_column"style="display:flex;border-top:0 solid transparent;border-left:0 solid transparent;border-right:0 solid transparent;border-bottom:0 solid transparent;border-radius:0"> <div class="v-col-padding"style="width:100%;padding:0"> <div id="u_content_text_9"class="u_content_text"style="overflow-wrap:break-word;padding:10px"> <div class="v-font-size"style="font-size:14px;line-height:140%;text-align:center;word-wrap:break-word"> <p style="font-size:14px;line-height:140%;text-align:center"><span style="font-size:30px;line-height:42px">ORDER CONTENTS</span></p> </div> </div> <div id="u_content_custom_shipaid_tools_2"class="u_content_custom_shipaid_tools"style="overflow-wrap:break-word;padding:10px"> <article style="background-color:#fff;overflow-y:auto;max-height:400px"class="product-container"> {{#each products}} <article class="product-content"style="color:#1664c0;background-color:#fff"> <div class="product-title"> {{item}} x {{item_quantity}} </div> </article> {{/each}} </article> </div> </div> </div> </div> </div> </div> </div> </body> </html>`,
  lastUpdated: null,
  platformIntegrationType: customEmailTemplateIntegrationTypes.custom,
  usage: templatesUsageTypes.tracking,
};

export const templateEventTypesVariables = {
  [customEmailTemplateTypes.AWAITING_SHIPMENT.key]: [
    'order_number',
    'recipient_name',
    'tracking_number',
    'delivery_date',
    'status',
  ],
  [customEmailTemplateTypes.AVALIABLE_FOR_PICKUP.key]: [
    'order_number',
    'recipient_name',
    'tracking_number',
    'delivery_date',
    'status',
  ],
  [customEmailTemplateTypes.DELIVERED.key]: [
    'order_number',
    'recipient_name',
    'tracking_number',
    'delivery_date',
    'status',
  ],
  [customEmailTemplateTypes.FAILED_TO_DELIVER.key]: [
    'order_number',
    'recipient_name',
    'tracking_number',
    'delivery_date',
    'status',
  ],
  [customEmailTemplateTypes.IN_TRANSIT.key]: [
    'order_number',
    'recipient_name',
    'tracking_number',
    'delivery_date',
    'status',
  ],
  [customEmailTemplateTypes.OUT_FOR_DELIVERY.key]: [
    'order_number',
    'recipient_name',
    'tracking_number',
    'delivery_date',
    'status',
  ],
  [customEmailTemplateTypes.RETURNED.key]: [
    'order_number',
    'recipient_name',
    'tracking_number',
    'delivery_date',
    'status',
  ],
  trackingDefault: [
    'order_number',
    'recipient_name',
    'tracking_number',
    'delivery_date',
    'status',
  ],
};

export const variablesPreviewResolver = {
  [customTemplateVariables.orderNumber.key]: () => '000000000000',
  [customTemplateVariables.recipientName.key]: () => 'Test Recipient',
  [customTemplateVariables.trackingNumber.key]: () => '000000000000',
  [customTemplateVariables.trackingPageUrl.key]: () =>
    process.env.REACT_APP_TARGET_ENV === 'development'
      ? window.location.origin
      : process.env.REACT_APP_TRACKING_PORTAL_URL,
  [customTemplateVariables.deliveryDate.key]: () =>
    format(new Date(), 'yyyy-MM-dd'),
  [customTemplateVariables.status.key]: (eventType: any) =>
    startCase(eventType),
  // [customTemplateVariables.company_email.key]: () => 'email@email.com',
  // [customTemplateVariables.delivery_day.key]: () => '25',
  // [customTemplateVariables.brand_name.key]: () => 'Brand Name',
};
